import styled from 'styled-components';
import { spacing } from '../../style/theme';

var getPadding = function getPadding(multiplier) {
  if (multiplier) {
    return spacing.base * multiplier + "px";
  }

  return null;
};

var HorizontalRule = styled.hr.withConfig({
  displayName: "HorizontalRule",
  componentId: "sc-7hihbn-0"
})(["margin-top:", ";margin-right:", ";margin-bottom:", ";margin-left:", ";"], function (_ref) {
  var top = _ref.top;
  return getPadding(top);
}, function (_ref2) {
  var right = _ref2.right;
  return getPadding(right);
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return bottom ? getPadding(bottom) : 0;
}, function (_ref4) {
  var left = _ref4.left;
  return getPadding(left);
});
export default HorizontalRule;